import React from 'react'
import { Field, ErrorMessage, FieldArray } from 'formik'
import { Row, Col, Card, CardBody, Label } from "reactstrap";
const OdcCargoType = ({ quotesForm, addContainerValidationSet, validateAddContainer }) => {
  const handleAddContainer = (arrayHelpers) => {
    validateAddContainer(true)    
    addContainerValidationSet &&
      arrayHelpers.insert(quotesForm.values.container.length + 1,
        {
          weightPerCargo: '',
          containerSize: '',
          containerType: '',
          length: '',
          width: '',
          height: '',
          netWeight: '',
          // weight: ''
        })
  }
  return (
    <>
      <Row className='justify-content-center'>
        <Col className='cargoType-component'>

          <div className='form-group'>
            <FieldArray name='container' render={
              (arrayHelpers) => {
                return <div>
                  {quotesForm.values.container.map((details, index) => (
                    <div className='mt-2 position-relative' key={index}>
                      <div className='close-icon float-end'>
                        <button className='btn btn-danger close-btn' hidden={quotesForm.values.container.length > 1 ? false : true} type='button' onClick={() => arrayHelpers.remove(index)}>X</button>
                      </div>
                      <div className='card' style={{ padding: 5 }}>
                        <div className='card-body'>
                          <Row>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <Label>Container Type<span>*</span></Label>
                                <Field component="div" className='selector' name={`container.${index}.containerType`}>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerType === 'OT' ? true : false}
                                      type="radio"
                                      id={`containerType.OT.${index}`}
                                      name={`container.${index}.containerType`}
                                      value="OT"
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerType.OT.${index}`} className='required-field'
                                      onClick={() => quotesForm.setFieldValue(`container.${index}.containerType`, 'OT')}>OT</Label>
                                  </div>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerType === 'FR' ? true : false}
                                      type="radio"
                                      id={`containerType.FR.${index}`}
                                      name={`container.${index}.containerType`}
                                      value="FR"
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerType.FR.${index}`} className='required-field'
                                      onClick={() => quotesForm.setFieldValue(`container.${index}.containerType`, 'FR')}>FR</Label>
                                  </div>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerType === 'HC OT' ? true : false}
                                      type="radio"
                                      id={`containerType.HCOT.${index}`}
                                      name={`container.${index}.containerType`}
                                      value="HC OT"
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerType.HCOT.${index}`} className='HCOT required-field'
                                      onClick={() => quotesForm.setFieldValue(`container.${index}.containerType`, 'HC OT')}>HC OT</Label>
                                  </div>
                                </Field>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.containerType`}
                                />
                              </div>
                            </Col>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <Label>Container Size<span>*</span></Label>
                                <Field component="div" className='selector' name={`container.${index}.containerSize`}>
                                  {
                                    (quotesForm.values.container[index].containerType !== 'HC OT') &&
                                    <div className="container-item">
                                      <input
                                        checked={quotesForm.values.container[index].containerSize === '20"' ? true : false}
                                        type="radio"
                                        id={`containerSize.20.${index}`}
                                        name={`container.${index}.containerSize`}
                                        value={`20"`}
                                        className='selector-item_radio'
                                        onChange={() => { }}
                                      />
                                      <Label htmlFor={`containerSize.20.${index}`} className='required-field' onClick={() => quotesForm.setFieldValue(`container.${index}.containerSize`, '20"')}>20"</Label>
                                    </div>
                                  }
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerSize === '40"' ? true : false}
                                      type="radio"
                                      id={`containerSize.40.${index}`}
                                      name={`container.${index}.containerSize`}
                                      value={`40"`}
                                      className='selector-item_radio'
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerSize.40.${index}`} className='required-field' onClick={() => quotesForm.setFieldValue(`container.${index}.containerSize`, '40"')}>40"</Label>
                                  </div>
                                </Field>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.containerSize`}
                                />
                              </div>
                            </Col>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <div className="mb-4 align-items-baseline">
                                  <Col>
                                    <Label htmlFor={`container.${index}.weightPerCargo`}>Gross weight(kg)<span> *</span></Label>
                                  </Col>
                                  <Col className='container-item'>
                                    <Field
                                      onWheel={(e) => e.target.blur()}
                                      type='number'
                                      className='form-control required-field'
                                      name={`container.${index}.weightPerCargo`}
                                      id={`container.${index}.weightPerCargo`}
                                    />
                                  </Col>
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.weightPerCargo`}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <div className="mb-4 align-items-baseline">
                                  <Col>
                                    <Label htmlFor={`container.${index}.netWeight`}>Net weight(kg)<span> *</span></Label>
                                  </Col>
                                  <Col className='container-item'>
                                    <Field
                                      onWheel={(e) => e.target.blur()}
                                      type='number'
                                      className='form-control required-field'
                                      name={`container.${index}.netWeight`}
                                      id={`container.${index}.netWeight`}
                                    />
                                  </Col>
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.netWeight`}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>


                          <div className='mb-3'>
                            <Row className="mb-4">
                              <Col sm={4} className='form-group'>
                                <div className='container-item'>
                                  <Label>Length(cm)<span>*</span></Label>
                                  <Field
                                    onWheel={(e) => e.target.blur()}
                                    type='number'
                                    className='form-control required-field'
                                    name={`container.${index}.length`}
                                    id={`container.${index}.length`}
                                  />
                                </div>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.length`}
                                />
                              </Col>
                              <Col sm={4} className='form-group'>
                                <div className='container-item'>
                                  <Label>Width(cm)<span>*</span></Label>
                                  <Field
                                    onWheel={(e) => e.target.blur()}
                                    type='number'
                                    className='form-control required-field'
                                    name={`container.${index}.width`}
                                    id={`container.${index}.width`}
                                  />
                                </div>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.width`}
                                />
                              </Col>
                              <Col sm={4} className='form-group'>
                                <div className='container-item'>
                                  <Label>Height(cm)<span>*</span></Label>
                                  <Field
                                    onWheel={(e) => e.target.blur()}
                                    type='number'
                                    className='form-control required-field'
                                    name={`container.${index}.height`}
                                    id={`container.${index}.height`}
                                  />
                                </div>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.height`}
                                />
                              </Col>
                              {/* <Col sm={3} className='form-group'>
                                    <div className='container-item'>
                                      <Label>Weight<span>*</span></Label>
                                      <Field
                                        type='text'
                                        className='form-control required-field'
                                        name={`container.${index}.weight`}
                                        id={`container.${index}.weight`}
                                      />
                                    </div>
                                    <ErrorMessage
                                      component='span'
                                      className='field_error'
                                      name={`container.${index}.weight`}
                                    />
                                  </Col> */}
                            </Row>
                          </div>

                        </div>
                      </div>
                    </div>
                  ))}
                  <div className='form-group float-end mt-2'>
                    <button type={'button'} className='primary-button'
                      onClick={() => handleAddContainer(arrayHelpers)}>Add Container</button>
                  </div>
                </div>
              }
            }>
            </FieldArray>
          </div>
        </Col>
      </Row>
    </>
  )
}
export default OdcCargoType